export function ctaLinkRegexParsing(path: URL) {
  return path.toString().replace(/\+/g, '%20');
}

export function addNoopener(rel?: string): string {
  const tokens = new Set((rel ?? '').split(/\s+/).filter(Boolean));
  tokens.add('noopener');
  return Array.from(tokens).join(' ');
}
